import { useContext, useState } from 'react'
import { Tab } from '@headlessui/react'
import { AuthProvider } from '../../../Context/AuthContext'
import SmallSpinner from '../../../Shared/Spinner/SmallSpinner'
import { Link } from 'react-router-dom'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Example({ onSubmit, handleSubmit, register, comments, blogData, loading }) {
    const { user } = useContext(AuthProvider)

    return (
        <div className="w-full px-2 py-16 sm:px-0">
            <Tab.Group>
                <Tab.List className="flex space-x-1 rounded-xl bg-blue-900/20 p-1">
                    <Tab
                        className={({ selected }) =>
                            classNames(
                                'w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-blue-700',
                                'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
                                selected
                                    ? 'bg-white shadow'
                                    : 'text-blue-100 hover:bg-white/[0.12] hover:text-white'
                            )
                        }
                    >
                        Comments
                    </Tab>
                    <Tab
                        className={({ selected }) =>
                            classNames(
                                'w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-blue-700',
                                'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
                                selected
                                    ? 'bg-white shadow'
                                    : 'text-blue-100 hover:bg-white/[0.12] hover:text-white'
                            )
                        }
                    >
                        Write Comment
                    </Tab>
                    <Tab
                        className={({ selected }) =>
                            classNames(
                                'w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-blue-700',
                                'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
                                selected
                                    ? 'bg-white shadow'
                                    : 'text-blue-100 hover:bg-white/[0.12] hover:text-white'
                            )
                        }
                    >
                        Others
                    </Tab>
                </Tab.List>
                <Tab.Panels className="mt-2">
                    <Tab.Panel
                        className={classNames(
                            'rounded-xl bg-white p-3',
                            'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2'
                        )}
                    >
                        <div className='mt-5'>
                            {
                                comments?.length === 0 ?

                                    <div>
                                        <h3 className='border-2 border-gray-300 p-7 lg:my-11 text-center font-semibold rounded-xl'>There are no Comment Releted to {blogData.category} based-post.</h3>
                                    </div>
                                    :
                                    comments?.map(comment =>
                                        <div className='flex items-start gap-5 pb-5 mb-7'>
                                            <img
                                                className='md:h-20 md:w-20 h-11 w-11 rounded-full'
                                                src={comment?.image} alt="" />
                                            <div>
                                                <h3 className='text-xl text-regal-orange fontsemibold pb-1'>{comment?.name}</h3>
                                                {/* <p className='text-sm text-gray-500'>Student of tmkmt</p> */}
                                                <p className='text-gray-400 text-sm '>{comment?.message}</p>
                                                <div className='flex items-center gap-2 pt-2'>
                                                    <p className='font-semibold underlined text-sm'>Reply</p>
                                                    <p className='text-gray-400 text-sm'>{comment?.date}</p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                            }
                        </div>
                    </Tab.Panel>
                    <Tab.Panel
                        className={classNames(
                            'rounded-xl bg-white p-3',
                            'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2'
                        )}
                    >
                        <div class="p-4 py-6 rounded-lg bg-gray-50 dark:bg-gray-800 md:p-8">
                            {
                                user?.uid ?
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div class="-mx-2 md:items-center md:flex">
                                            <div class="flex-1 px-2">
                                                <label class="block mb-2 text-sm text-gray-600 dark:text-gray-200">Name</label>
                                                <input type="text" placeholder="John " class="block w-full px-5 py-2.5 mt-2 text-gray-700 placeholder-gray-400 bg-white border border-gray-200 rounded-lg dark:placeholder-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40"
                                                    {...register("name")}
                                                    defaultValue={user?.displayName}
                                                    disabled
                                                />
                                            </div>

                                            <div class="flex-1 px-2 mt-4 md:mt-0">
                                                <label class="block mb-2 text-sm text-gray-600 dark:text-gray-200">Email address</label>
                                                <input type="email" placeholder="johndoe@example.com" class="block w-full px-5 py-2.5 mt-2 text-gray-700 placeholder-gray-400 bg-white border border-gray-200 rounded-lg dark:placeholder-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40"
                                                    {...register("email")}
                                                    defaultValue={user?.email}
                                                    disabled
                                                />
                                            </div>
                                        </div>


                                        <div class="w-full mt-4">
                                            <label class="block mb-2 text-sm text-gray-600 dark:text-gray-200">Message</label>
                                            <textarea class="block w-full h-32 px-5 py-2.5 mt-2 text-gray-700 placeholder-gray-400 bg-white border border-gray-200 rounded-lg dark:placeholder-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Message"
                                                {...register("message")}
                                            ></textarea>
                                        </div>

                                        <div className='md:flex md:justify-end'>
                                            <button type='submit' class="w-full md:w-44  px-6 py-3 mt-4 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-lg hover:bg-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50 flex items-center justify-center">
                                                {
                                                    loading ?
                                                        <SmallSpinner />
                                                        :
                                                        "Send Message"
                                                }
                                            </button>
                                        </div>
                                    </form>
                                    :
                                    <div className='flex items-center flex-col justify-center border-2 rounded-2xl border-gray-300 p-7 '>
                                        <h3 className='font-semibold text-xl text-center'>Please signin first for commenting</h3>
                                        <Link to='/signin' className='block px-6 py-2.5 mt-3 font-medium leading-5 text-center text-white capitalize bg-blue-600 rounded-lg  hover:bg-blue-500 lg:w-auto'>Sign In</Link>
                                    </div>
                            }
                        </div>
                    </Tab.Panel>
                    <Tab.Panel
                        className={classNames(
                            'rounded-xl bg-white p-3',
                            'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2'
                        )}
                    >

                    </Tab.Panel>
                </Tab.Panels>
            </Tab.Group>
        </div>
    )
}
